import { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';

import useAuthentication from 'domain/authentication/useAuthentication';
import LoadStatus from 'config/load_status';

import delayed from 'utils/delayed';

import bookmarkRecipe from './usecases/bookmark_recipe';

const useBookmarkRecipe = ({ recipeID, bookmarked, onDone }) => {
  const { isAuthenticated } = useAuthentication();
  const { enqueueSnackbar } = useSnackbar();
  const [bookmarkStatus, setBookmarkStatus] = useState(null);

  useEffect(() => {
    if (bookmarkStatus !== LoadStatus.LOADING) return;

    const postData = async () => {
      if (!isAuthenticated) {
        setBookmarkStatus(LoadStatus.ERROR);
        enqueueSnackbar('You are not authenticated', {
          variant: 'error',
        });
        return;
      }

      try {
        await delayed(bookmarkRecipe(recipeID, !bookmarked));
        setBookmarkStatus(LoadStatus.DONE);
        onDone(!bookmarked);
      } catch (error) {
        setBookmarkStatus(LoadStatus.ERROR);
        enqueueSnackbar('It was not possible to bookmark recipe', {
          variant: 'error',
        });
        throw error;
      }
    };
    postData();
  }, [
    bookmarkStatus,
    enqueueSnackbar,
    recipeID,
    bookmarked,
    onDone,
    isAuthenticated,
  ]);

  const onBookmarked = () => {
    if (bookmarkStatus === LoadStatus.LOADING) return;
    setBookmarkStatus(LoadStatus.LOADING);
  };

  return {
    onBookmarked,
    isBookmarking: bookmarkStatus === LoadStatus.LOADING,
  };
};

export default useBookmarkRecipe;
